import { GridSize } from 'vendor/material';

// Helper functions to calculate grid sizes based on company name length
export const calculateCompanyNameGridSize = (companyName: string): GridSize => {
  const length = companyName?.length || 0;
  if (length > 30) return 6;
  if (length > 20) return 5;
  return 4;
};

export const calculateAmountGridSize = (companyName: string): GridSize => {
  const companyGridSize = calculateCompanyNameGridSize(companyName);
  const remainingSpace = 12 - (companyGridSize as number) - 4;
  // Ensure we return a valid grid size (clamp between 2-12)
  if (remainingSpace >= 6) return 6;
  if (remainingSpace >= 4) return 4;
  if (remainingSpace >= 3) return 3;
  return 2;
};
